<template src="./index.html"></template>
<script>
import { getdata } from './data.js';
import configHttp from '../../../../../../configHttp';
import comMapping from '../../../../../comMapping';
export default {
	props: {
		activeName: {
			type: String,
			default: '0'
		}
	},
	data() {
		return {
			comMapping: comMapping,
			headData: getdata().headData,
			headData2: getdata().headData2,
			jgData: JSON.parse(localStorage.getItem('../components/page/AllelectricInvoice/ManualExportAndImport/ResultWriteBack')) || getdata().jgData,
			outlist: JSON.parse(localStorage.getItem('../components/page/AllelectricInvoice/ManualExportAndImport/ResultWriteBack')) || [],
			//表格搜索
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			//表格
			tableHeight: null,
			tableData: [],
			tableDatafq: [],
			tableDatabs: [],
			tablekey: 0,
			pagination: getdata().pagination,
			faphx: false,
			banshx: false,
			//排序字段名称
			order: '',
			//排序顺序
			sort: '',
			importErrorLogContent: '',
			dialogvisibleview: false
		};
	},
	watch: {
		activeName: function(indexVal, oldVal) {
			this.$emit('active', indexVal);
		}
	},
	created() {
	},
	mounted() {
		this.DataQuery();

	},
	methods: {
		//排序
		sortchange(e) {
			console.log(e);
			this.order = e.prop;
			if (e.order == 'ascending') {
				this.sort = 'ASC';
			} else if (e.order == 'descending') {
				this.sort = 'DESC';
			} else {
				this.sort = '';
			}
			this.DataQuery();
		},
		//确认返回
		fphxtk() {
			this.DataQuery();
			this.faphx = false;
			this.banshx = false;
		},
		//发票回写板式回写弹框
		shuax(k) {
			if (k == 1) {
				let patea = {
					limit: 999999999,
					page: 1
				};
				this.$https.fetchPost('felec/manual/manualImport/result', patea).then(res => {
					if (res.data.code == '200') {
						// this.pagination.total = res.data.count;
						this.tableDatafq = res.data.data.map(v => {
							if (v.taskEndTime != null) {
								if (v.taskEndTime.length == 8) {
									var reg = /^(\d{4})(\d{2})(\d{2})$/;
									v.taskEndTime = v.taskEndTime.replace(reg, '$1年$2月$3日');
								} else if (v.taskEndTime.length == 14) {
									var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
									v.taskEndTime = v.taskEndTime.replace(reg, '$1年$2月$3日 $4时$5分$6秒');
								}
							}
							if (v.taskStartTime != null) {
								if (v.taskStartTime.length == 8) {
									var reg = /^(\d{4})(\d{2})(\d{2})$/;
									v.taskStartTime = v.taskStartTime.replace(reg, '$1年$2月$3日');
								} else if (v.taskStartTime.length == 14) {
									var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
									v.taskStartTime = v.taskStartTime.replace(reg, '$1年$2月$3日 $4时$5分$6秒');
								}
							}
							return v;
						});
						this.faphx = true;
					} else {
						this.$message.error('失败');
					}
				});
			} else {
				let patea = {
					limit: 999999999,
					page: 1
				};
				this.$https.fetchPost('felec/manual/formatImport/result', patea).then(res => {
					if (res.data.code == '200') {
						// this.pagination.total = res.data.count;
						this.tableDatabs = res.data.data.map(v => {
							if (v.taskEndTime != null) {
								if (v.taskEndTime.length == 8) {
									var reg = /^(\d{4})(\d{2})(\d{2})$/;
									v.taskEndTime = v.taskEndTime.replace(reg, '$1年$2月$3日');
								} else if (v.taskEndTime.length == 14) {
									var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
									v.taskEndTime = v.taskEndTime.replace(reg, '$1年$2月$3日 $4时$5分$6秒');
								}
							}
							if (v.taskStartTime != null) {
								if (v.taskStartTime.length == 8) {
									var reg = /^(\d{4})(\d{2})(\d{2})$/;
									v.taskStartTime = v.taskStartTime.replace(reg, '$1年$2月$3日');
								} else if (v.taskStartTime.length == 14) {
									var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
									v.taskStartTime = v.taskStartTime.replace(reg, '$1年$2月$3日 $4时$5分$6秒');
								}
							}
							return v;
						});
						this.banshx = true;
					} else {
						this.$message.error('失败');
					}
				});
			}
		},
		//获取导入日志
		forfile(row) {
			let id = row.taxval.id;
			this.$https.fetchPost('felec/manual/download/importLog?id=' + id).then(res => {
				let message = res.data;
				if (res.status == '200') {
					this.importErrorLogContent = message;
					this.dialogvisibleview = true;
				} else {
					this.$message.error('获取导入日志失败');
				}
			});
		},
		//发票回写文件上传
		fpDocumentType() {
			this.$upload({
				uploadurl: configHttp.baseURL + 'felec/manual/manualImport',
				uploadtitle: '选择文件',
				accept: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				params: {
					token: localStorage.getItem('token')
				}
			}).then(res => {
				if (res != 'cancel') {
					if (res.code == '200') {
						this.$message.success('导入成功');
						this.shuax(1);
					} else {
						this.$message.error('导入失败：' + res.message);
					}
				}
			});
		},
		//板式回写文件上传
		bsDocumentType() {
			this.$upload({
				uploadurl: configHttp.baseURL + 'felec/manual/formatImport',
				uploadtitle: '选择文件',
				accept: 'application/pdf,.ofd,application/xml,application/zip',
				message: '支持OFD、PDF、XML以及含上述文件的ZIP包',

			}).then(res => {
				if (res != 'cancel') {
					if (res.code == '200') {
						this.$message.success('导入成功');
						this.shuax(2);
					} else {
						this.$message.error('导入失败：' + res.message);
					}
				}
			});
		},
		DataQuery() {
      //todo 需要加双日判断
      if (configHttp.shuangRiTaxNumber) {
        let shuangRiTaxNumber = configHttp.shuangRiTaxNumber;
        let userobj = JSON.parse(localStorage.getItem('useropj'));
        let qiybh = userobj.currCompany.code;
        if (shuangRiTaxNumber.includes(qiybh)) {
          this.searchdata.fapzl = "2";
          this.searchdata.cank1 = "3";
        }
      }

			let patea = {
				limit: this.pagination.pageSize,
				page: this.pagination.pageNum,
				order: this.order,
				sort: this.sort,
				param: JSON.parse(JSON.stringify(this.searchdata))
			};
			this.$https.fetchPost('felec/manual/getDocList/rewrite', patea).then(res => {
				if (res.data.code == '200') {
					this.pagination.total = res.data.count;
					this.tableData = res.data.data.map(v => {
						if (v.kaiprq != null) {
							if (v.kaiprq.length == 8) {
								var reg = /^(\d{4})(\d{2})(\d{2})$/;
								v.kaiprq = v.kaiprq.replace(reg, '$1年$2月$3日');
							} else if (v.kaiprq.length == 14) {
								var reg = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/;
								v.kaiprq = v.kaiprq.replace(reg, '$1年$2月$3日');
							}
						}
						return v;
					});
					this.$nextTick(()=>{
							this.$refs.tablebox.doout();
					})
				} else {
					this.$message.error('失败');
				}
			});
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('../components/page/AllelectricInvoice/ManualExportAndImport/ResultWriteBack', JSON.stringify(e.nochooselist));
			localStorage.setItem('../components/page/AllelectricInvoice/ManualExportAndImport/ResultWriteBack', JSON.stringify(e.chooselist));
			this.jgData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		},
		//表格搜索
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.DataQuery();
		},
		//表格分页
		sizechange(e) {
			this.pagination.pageSize = e;
			this.DataQuery();
		},
		currentChange(e) {
			this.pagination.pageNum = e;
			this.DataQuery();
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
